module.exports = __webpack_public_path__ + "static/3-8093ad0eac1ac1d3a438c31859853aac.wav";